<template>
  <div
    v-if="product && !isComingSoon
      && $feature.showSizeChartButtonOnPDP
      && (product.sizeChart || $feature.showFitFinderOnPDP || product.fitSize)"
    class="body-5 underlined"
  >
    <base-button v-if="product.sizeChart" id="pdp-size-chart" class="flex gap-1 items-center" @click="openSizeGuide">
      <vf-icon v-if="showSizeChartIcon" name="size" size="sm" />
      {{ $t.sizeChart }}
    </base-button>
    <base-button v-else-if="product.fitSize">
      {{ $t.findYourSize }}
    </base-button>
  </div>
</template>

<script setup lang="ts">
const { showSizeChartIcon } = useAppConfig().pages.pdp.sizeAndFit
const { isComingSoon, openSizeGuide, product } = usePdp()
</script>
